<template>
  <div class="bg-gray-800 rounded-t-none rounded-lg pb-2">
    <div class="bg-gray-800 py-2">
      <div class="flex justify-between px-4 pt-2">
        <div
          @click="
            setMaxChars(30)
            $emit('closeMenu')
          "
          class="flex flex-col items-center cursor-pointer"
        >
          <img
            v-if="question.max_chars === 30"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/characters30On.svg"
            alt="Characters 30 on"
          />
          <img
            v-else
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/characters30Off.svg"
            alt="Characters 30 off"
          />
          <div class="pt-1 text-center" :class="[question.max_chars === 30 ? 'text-white' : 'text-gray-600']">
            Max. 30<br />caractères
          </div>
        </div>
        <div
          @click="
            setMaxChars(120)
            $emit('closeMenu')
          "
          class="flex flex-col items-center cursor-pointer"
        >
          <img
            v-if="question.max_chars === 120"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/characters120On.svg"
            alt="Characters 120 on"
          />
          <img
            v-else
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/characters120Off.svg"
            alt="Characters 120 off"
          />
          <div class="pt-1 text-center" :class="[question.max_chars === 120 ? 'text-white' : 'text-gray-600']">
            Max. 120<br />caractères
          </div>
        </div>
        <div
          @click="
            setMaxChars(240)
            $emit('closeMenu')
          "
          class="flex flex-col items-center cursor-pointer"
        >
          <img
            v-if="question.max_chars === 240"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/characters240On.svg"
            alt="Characters 240 on"
          />
          <img
            v-else
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/characters240Off.svg"
            alt="Characters 240 off"
          />
          <div class="pt-1 text-center" :class="[question.max_chars === 240 ? 'text-white' : 'text-gray-600']">
            Max. 240<br />caractères
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      question: (state) => state.question,
    }),
  },
  methods: {
    ...mapMutations("question", ["setMaxChars"]),
  },
}
</script>

<style></style>
